import React from 'react';
import PropTypes from 'prop-types';
import Autobind from 'autobind-component';
import styles from './index.scss';
import Game from 'game';

class UserPortal extends Autobind {

  render() {
    return (
      <div style={{backgroundColor: "#808080"}} className={ styles.UserPortalWrapper }>      
        <Game />       
      </div>
    );
  }
}

UserPortal.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
}

export default UserPortal;



// WEBPACK FOOTER //
// ./src/userportal/userportal.presentation.jsx